import React from 'react';
import ScrollArrow from '../ScrollArrow';
import { Alert, AlertTitle } from '@mui/material';
 
export default function Hero() {
  return (
    <div>
      <Alert severity="info" variant="filled">
        I am currently open for work. If you'd like to reach out to connect, please <b><a className="info-link" href="mailto:tori.rossini42@gmail.com">email me</a></b>.
      </Alert>
      <div className='tbox'>
        <div className='p-5 hero-image d-flex'>
          <div className='mask mask-align container-fluid d-flex justify-content-center align-items-center ' id='overlay' style={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}>
              <div className='text-white hero-text'>
                <h1 className='mb-3 display-1 goldman-bold '>Tori Rossini</h1>
                <h4 className='mb-3 display-6 carter-one-regular'>Software Engineer and Game Developer</h4>
              </div>
          </div>
        </div>
      </div>

      <ScrollArrow></ScrollArrow>

      </div>
  );
}